var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template_card",class:_vm.item.item_type},[_c('div',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm.type[_vm.item.item_type])+" ")]),_c('div',{staticClass:"time"},[_c('cl-svg-icon',{attrs:{"icon-class":"clock"}}),_vm._v(" "+_vm._s(_vm.item.start)+"-"+_vm._s(_vm.item.end)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }